import { __awaiter, __generator } from "tslib";
import { mergeObjects } from '../../common/utilities/merge-objects';
import { fetchCartSetting } from './fetch-cart-setting';
import { fetchPriceDisplaySetting } from './fetch-price-display-setting';
import { fetchEcomSetting } from './fetch-ecom-setting';
/**
 * Fetches for cart, display and ecom settings.
 * @deprecated Do not use it, will be deleted in future
 * @remarks The method is used very rare or even once.
 *          Might work even faster if at least one of the setting has already been fetched.
 */
export var fetchAllSiteSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
    var cartSetting, displaySetting, ecomSetting;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchCartSetting()];
            case 1:
                cartSetting = _a.sent();
                return [4 /*yield*/, fetchPriceDisplaySetting()];
            case 2:
                displaySetting = _a.sent();
                return [4 /*yield*/, fetchEcomSetting()];
            case 3:
                ecomSetting = _a.sent();
                return [2 /*return*/, mergeObjects({}, cartSetting, displaySetting, ecomSetting)];
        }
    });
}); };
